import React from 'react'
import LoadingButton from '../loading-button'
import type { AddToDiscoUser } from 'types/user'
import { useTranslation } from '@disco/i18n/use-translation'

type Props = {
  user: AddToDiscoUser
  captchaToken?: string
  errorCode?: string | null | undefined
  isTransitioning?: boolean
}

const LoginButton = ({
  user,
  captchaToken,
  errorCode,
  isTransitioning,
}: Props): React.ReactNode => {
  const { t } = useTranslation('accounts')
  const { loggingIn, showLoginError, mfaCodeRequired } = user
  const loading = loggingIn || isTransitioning

  if (mfaCodeRequired) {
    return (
      <LoadingButton
        type="submit"
        size="3"
        color="gray"
        variant="solid"
        highContrast
        radius="medium"
        loading={loading}
        loadingLabel={t('accounts:verifyingCode', 'Verifying…')}
        data-testid="button-black"
      >
        {t('accounts:verify', 'Verify')}
      </LoadingButton>
    )
  }

  return (
    <LoadingButton
      type="submit"
      size="3"
      color="gray"
      variant="solid"
      highContrast
      radius="medium"
      disabled={
        showLoginError && errorCode === 'CAPTCHA_REQUIRED' && !captchaToken
      }
      loading={loading}
      loadingLabel={t('accounts:signingIn', 'Signing in…')}
      data-testid="button-black"
    >
      {t('accounts:signInToDisco', 'Sign in to DISCO')}
    </LoadingButton>
  )
}

export default LoginButton
